/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { useVueProps, vueDefaultValue } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
/**
 * Component ButtonBox is under construction.
 * The required functionality should be added while needed it from the _button-box.html.erb file.
 */
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./ButtonBox.react.scss";

const sizes = {
  small: "small",
  large: "large",
  normal: "normal"
};
const styles = {
  primary: "primary",
  secondary: "secondary",
  terceary: "terceary",
  outline: "outline",
  outlineInherit: "outline-inherit",
  linkInherit: "link-inherit",
  special: "special",
  appPrimary: "app-primary",
  appSecondary: "app-secondary"
};

// @ts-expect-error TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    href: vueDefaultValue(undefined),
    size: vueDefaultValue("normal"),
    style: vueDefaultValue("default"),
    icon: vueDefaultValue(""),
    iconSize: vueDefaultValue("0"),
    svgColor: vueDefaultValue(null),
    block: vueDefaultValue(false),
    slim: vueDefaultValue(false),
    noSlot: vueDefaultValue(false),
    disabled: vueDefaultValue(false)
  };
}

export default function ButtonBox(rawProps: any) {
  const {
    className,
    href,
    size,
    style,
    icon,
    iconSize,
    svgColor,
    block,
    slim,
    noSlot,
    disabled,
    ...restProps
  } = rawProps;

  const props = useVueProps(rawProps, getDefaultProps);

  function tag() {
    return props.current.href ? "a" : "button";
  }

  function hasSlot() {
    return {
      default: () => rawProps.children,
      ...(props.current.slots || {})
    }.default;
  }

  function dynamicClasses() {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const classSize = `button-box--size-${sizes[props.current.size] || sizes.normal}`;
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const classStyle = styles[props.current.style]
      ? // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        `button-box--style-${styles[props.current.style]}`
      : "";
    const classIcon =
      (!hasSlot() && props.current.icon) || props.current.noSlot ? "button-box--round" : "";
    const classBlock = props.current.block ? "button-box--block" : "";
    const classSlim = props.current.slim ? "button-box--slim" : "";
    return `${classSize} ${classStyle} ${classIcon} ${classBlock} ${classSlim}`;
  }

  return (
    <>
      {(() => {
        const DynamicTag = tag();
        return (
          <DynamicTag
            className={cn(["button-box scope-40f74578", dynamicClasses()], className)}
            href={props.current.href}
            disabled={props.current.disabled}
            {...restProps}
            data-testid="button-box"
          >
            {props.current.icon ? (
              <UseSvg
                className={cn("button-box__icon", "scope-40f74578")}
                icon={props.current.icon}
                width={props.current.iconSize}
                height={props.current.iconSize}
                style={{
                  color: props.current.svgColor
                }}
                alt={props.current.icon}
                data-testid="button-box-icon"
              />
            ) : null}
            {hasSlot() && !props.current.noSlot ? (
              <span className={cn("button-box__text", "scope-40f74578")}>{rawProps.children}</span>
            ) : null}
          </DynamicTag>
        );
      })()}
    </>
  );
}
